/**
 * Application-wide constants
 */

// API Endpoints
export const API_ENDPOINTS = {
  HEBREW_DATE_CONVERTER: 'https://www.hebcal.com/converter',
};

// Application Configuration
export const APP_CONFIG = {
  NAME: 'Avne Chen',
  VERSION: '1.0.0',
};

// Form Options
export const FORM_OPTIONS = {
  SUFFIX: [
    { label: '', value: '' },
    { label: 'ז״ל', value: 'ז״ל' },
    { label: 'זצ״ל', value: 'זצ״ל' },
    { label: 'ע״ה', value: 'ע״ה' },
  ],
  GRIEVE_WORDS: [
    { label: '', value: '' },
    {
      label: 'בצער רב וביגון קודר אנו מודיעים על פטירת',
      value: 'בצער רב וביגון קודר אנו מודיעים על פטירת',
    },
    {
      label: 'בצער וביגון אנו נפרדים מאהבת חיינו',
      value: 'בצער וביגון אנו נפרדים מאהבת חיינו',
    },
    {
      label: 'איבדנו את היקר לנו מכל',
      value: 'איבדנו את היקר לנו מכל',
    },
  ],
  CLOSENESS: [
    { label: '', value: '' },
    { label: 'אבינו, סבינו וחברינו היקר', value: 'אבינו, סבינו וחברינו היקר' },
    { label: 'אימנו', value: 'אימנו' },
    { label: 'אבינו', value: 'אבינו' },
  ],
  MEMORIAL_PLACES: [
    { label: '', value: '' },
    { label: 'אילת - בית העלמין אילת', value: 'אילת - בית העלמין אילת' },
  ],
};

// External Links
// Note: Vite uses import.meta.env for environment variables
const getShopUrl = () => {
  // Check both VITE_ and REACT_APP_ prefixes for backward compatibility
  const viteKey = 'VITE_REACT_APP_SHOP_URL';
  if (import.meta.env[viteKey] || import.meta.env.VITE_SHOP_URL) {
    return import.meta.env[viteKey] || import.meta.env.VITE_SHOP_URL;
  }
  return 'https://avnechen.myshopify.com/';
};

export const EXTERNAL_LINKS = {
  SHOP: getShopUrl(),
};

